import { render, staticRenderFns } from "./chat-item-bill.vue?vue&type=template&id=41dac485"
import script from "./chat-item-bill.vue?vue&type=script&lang=js"
export * from "./chat-item-bill.vue?vue&type=script&lang=js"
import style0 from "./chat-item-bill.vue?vue&type=style&index=0&id=41dac485&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports